import { render, staticRenderFns } from "./tennis-club-member-fee-collection.vue?vue&type=template&id=61bca22f"
import script from "./tennis-club-member-fee-collection.vue?vue&type=script&lang=ts"
export * from "./tennis-club-member-fee-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports